// ##### 25-05-02 Komarov
import React from 'react';
// ##### 25-05-21 Komarov
import SpaceTag from './SpaceTag';

// ##### Komarov 2025-07-23
const TourMonthDiv = ({
  transform,
  onChange,
  disabledDate,
  datepickerClass,
  isTourMonthDivOpened
}) => {
  return (
    <div style={{ transform }} data-component="TourMonthDiv">
      {/* ##### 23-11-21 Komarov */}
      <SpaceTag
        onChange={onChange}
        disabledDate={disabledDate}
        datepickerClass={datepickerClass}
        isTourMonthDivOpened={isTourMonthDivOpened}
      />
    </div>
  );
};

export default TourMonthDiv;
